import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Services from './components/ServicesSection';
import About from './components/AboutSection';
import Contact from './pages/ContactPage';
import Portfolio from './pages/PortfolioPage';
import NotFound from './pages/NotFound';
import Layout from './components/Layout';
import InvoiceGenerator from './pages/InvoicePage';
import ScrollToTop from './components/ScrollToTop';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Homepage with Hero + Sections */}
        <Route
          path="/"
          element={
            <Layout currentPage="/">
              <Hero />
              <Services />
              <About />
              <Contact />
            </Layout>
          }
        />
        <Route
          path="/portfolio"
          element={
            <Layout currentPage="/portfolio">
              <Portfolio />
            </Layout>
          }
        />
        {/* Separate Contact page if needed */}
        <Route
          path="/contact"
          element={
            <Layout currentPage="/contact">
              <Contact />
            </Layout>
          }
        />
        <Route path="/invoice-generator" element={<InvoiceGenerator />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;

// const App = () => {
// 	const [showBackToTop, setShowBackToTop] = useState(false);
// 	const [showNavbar, setShowNavbar] = useState(true);

// 	useEffect(() => {
// 		const handleScroll = () => {
// 			if (window.scrollY > 200) { // Adjust scroll threshold as needed
// 				setShowBackToTop(true);
// 				setShowNavbar(false);
// 			} else {
// 				setShowBackToTop(false);
// 				setShowNavbar(true); // Show navbar
// 			}
// 		};

// 		window.addEventListener('scroll', handleScroll);
// 		return () => window.removeEventListener('scroll', handleScroll); // clean up
// 	}, []);

// 	const scrollToTop = () => {
// 		window.scrollTo({
// 			top: 0,
// 			behavior: 'smooth', // For a smooth scroll effect
// 		})
// 	}

// 	return (
// 		<Router>
// 			<div className="App">
// 			{showNavbar && ( // Conditionally render the navbar
// 				<nav>
// 					<ul>
// 						<li><Link to="/">Home</Link></li>
// 						<li><Link to="/services">Services</Link></li>
// 						<li><Link to="/portfolio">Portfolio</Link></li>
// 						<li><Link to="/about">About Us</Link></li>
// 						<li><Link to="/contact">Contact</Link></li>
// 					</ul>
// 				</nav>
// 			)}

// 				<Routes>
// 					<Route path="/" element={<Home />} />
// 					<Route path="/services" element={<Services />} />
// 					<Route path="/portfolio" element={<Portfolio />} />
// 					<Route path="/about" element={<About />} />
// 					<Route path="/contact" element={<Contact />} />
// 					<Route path="/services/starter-website-info" element={<StarterWebsite />} /> {/* Example of a nested route */}
// 					<Route path="/services/business-website-info" element={<BusinessWebsite />} /> 
// 					<Route path="/services/premium-website-info" element={<PremiumWebsite />} />
// 					<Route path="/services/basic-plan-info" element={<BasicPlan />} />
// 					<Route path="/services/standard-plan-info" element={<StandardPlan />} />
// 					<Route path="/services/premium-plan-info" element={<PremiumPlan />} />
// 					{/* Add more routes as needed */}
// 				</Routes>
// 				{showBackToTop && (
// 					<button className="back-to-top" onClick={scrollToTop}>
// 						Back to Top
// 					</button>
// 				)}
// 			</div>
// 		</Router>
// 	);
// }

// export default App;
